export default "__VITE_ASSET__ddfd77ff__"